// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"370":"ce54089838d2427f37f15b4b3f2391410e0d2e41","678":"component---src-pages-index-js","793":"component---src-pages-body-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"370":"f89630a4397344bff33b","678":"ce177dec1cd6a6c86c6f","793":"e18770fa1663471ab164","883":"e4d77372e66f7426c50a"}[chunkId] + ".js";
};